export default args => args.every(arg => arg);
